/**
 * Image Element Renderer
 */

import { BaseElementRenderer, type ElementRenderContext } from './base-element-renderer';

export class ImageRenderer extends BaseElementRenderer {
  canRender(elementType: string): boolean {
    return elementType === 'image';
  }
  
  render(context: ElementRenderContext) {
    const { element, maxElementHeight, shouldStretchHorizontal, shouldStretchVertical, isSelected, onClick, elementStyle } = context;
    
    let effectiveHeight = element.height || 100;
    let effectiveWidth = element.width || 200;
    
    if (maxElementHeight && effectiveHeight > maxElementHeight) {
      const ratio = maxElementHeight / effectiveHeight;
      effectiveHeight = maxElementHeight;
      effectiveWidth = Math.round(effectiveWidth * ratio);
    }
    
    const imageStyle: React.CSSProperties = {
      width: shouldStretchHorizontal ? '100%' : effectiveWidth,
      height: shouldStretchVertical ? '100%' : effectiveHeight,
      outline: isSelected ? '2px solid #3b82f6' : 'none',
      // Apply margins from elementStyle
      marginTop: element.marginTop ? `${element.marginTop}px` : undefined,
      marginBottom: element.marginBottom ? `${element.marginBottom}px` : undefined,
      marginLeft: element.marginLeft ? `${element.marginLeft}px` : undefined,
      marginRight: element.marginRight ? `${element.marginRight}px` : undefined,
    };

    return (
      <div 
        className="border-2 border-dashed border-primary rounded bg-primary/10 overflow-hidden cursor-pointer"
        style={imageStyle}
        onClick={onClick}
      >
        {('imageUrl' in element && element.imageUrl) ? (
          <img 
            src={'imageUrl' in element ? element.imageUrl as string : ''} 
            alt="" 
            className="w-full h-full"
            style={{ objectFit: 'fill' }}
          />
        ) : (
          <div className="w-full h-full flex flex-col items-center justify-center gap-1 p-1">
            <svg className="w-6 h-6 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
            </svg>
            <span className="text-primary text-xs font-medium">Bild hochladen</span>
          </div>
        )}
      </div>
    );
  }
}
